/**
 * @generated SignedSource<<476fe64457d6c23038710ff365286f10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsCustomization_item$data = {
  readonly isCustomizable: boolean | null;
  readonly isDyoCustomizable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item" | "useCustomizationOptions_item">;
  readonly " $fragmentType": "PdpRespSidebarDetailsCustomization_item";
};
export type PdpRespSidebarDetailsCustomization_item$key = {
  readonly " $data"?: PdpRespSidebarDetailsCustomization_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsCustomization_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsCustomization_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomizationOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c90c2271e0830ad90de5ec23cd9a127e";

export default node;
